<template>
	<div>
		<!-- Tabs here -->
		<div>
			<case-explorer-tabs
				:tabs="computedTabs"
				@tab:clicked="setTab($event.id)"
			/>
		</div>

		<!-- Views Here -->
		<div class="md-p8 p4 max2 margin-center">
			<!-- Case Overview -->
			<case-overview v-if="genericViewId === 'overview'" />

			<!-- Case Proposals -->
			<template v-else-if="genericViewId === 'proposals'">
				<!-- Proposals -->
				<proposal-list
					v-if="genericViewChildrenViewId === 'proposalsList'"
					@proposal:clicked="
						setProposalViewId('proposalDetail', { proposalId: $event })
					"
					@proposal:policies_created="
						$emit('proposal:policies_created', $event)
					"
				/>

				<!-- Proposal Detail -->
				<proposal-detail
					v-else-if="genericViewChildrenViewId === 'proposalDetail'"
					@offer:click="setOfferViewId('offerDetail', $event)"
					@go:back="setProposalViewId('proposalsList')"
				/>

				<!-- Offer Detail -->
				<offer-detail
					v-else-if="genericViewChildrenViewId === 'offerDetail'"
					@go:back="
						setProposalViewId('proposalDetail', {
							proposalId: $store.state.caseManagement.proposalId
						})
					"
				/>
			</template>
		</div>
	</div>
</template>

<script>
import CaseExplorerTabs from "./CaseExplorerTabs"
import CaseOverview from "./CaseOverview"
import ProposalList from "./ProposalList"
import ProposalDetail from "./ProposalDetail"
import OfferDetail from "./OfferDetail"

export default {
	components: {
		CaseExplorerTabs,
		CaseOverview,
		ProposalList,
		ProposalDetail,
		OfferDetail
	},

	data() {
		return {
			genericViewId: "", // selected tab
			genericViewChildrenViewId: "proposalsList", // what view to display for proposals tab

			tabs: [
				{
					id: "overview",
					label: this.$t("overview"),
					isSelected: false
				},
				{
					id: "proposals",
					label: this.$t("proposals"),
					isSelected: false
				}
			]
		}
	},

	computed: {
		// Will go through this.tabs and based on `this.genericViewId` will add `isSelected` property accordingly
		computedTabs() {
			return this.tabs.map(tab => {
				tab.isSelected = false
				if (tab.id === this.genericViewId) tab.isSelected = true
				return tab
			})
		}
	},

	methods: {
		setTab(tabId) {
			this.genericViewId = tabId
			this.genericViewChildrenViewId = "proposalsList" // reset view to proposals list

			// Update router
			this.$router.push({
				query: {
					genericViewId: tabId,
					genericViewChildrenViewId: "proposalsList"
				}
			})
		},

		setProposalViewId(viewId, meta = {}) {
			// Set view
			this.genericViewChildrenViewId = viewId

			// Update router
			this.$router.push({
				query: {
					genericViewId: this.genericViewId,
					genericViewChildrenViewId: viewId
				}
			})

			// If genericViewChildrenViewId === 'proposalDetail' select prposalId in store
			if (viewId === "proposalDetail")
				this.$store.commit("caseManagement/SET_PROPOSAL_ID", meta.proposalId)
		},

		setOfferViewId(viewId, offerId) {
			// Set view
			this.genericViewChildrenViewId = viewId

			// Update router
			this.$router.push({
				query: {
					genericViewId: this.genericViewId,
					genericViewChildrenViewId: viewId
				}
			})

			this.$store.commit("caseManagement/SET_OFFER_ID", offerId)
		}
	},

	mounted() {
		// this.setTab("overview")

		// Set initial state
		this.$router.replace({
			query: {
				genericViewId: "overview",
				genericViewChildrenViewId: ""
			}
		})
	},

	watch: {
		$route: {
			handler() {
				this.genericViewId = this.$route.query?.genericViewId
				this.genericViewChildrenViewId = this.$route.query?.genericViewChildrenViewId
			},
			immediate: true
		}
	}
}
</script>
